import { render } from "./MultiWallet.vue?vue&type=template&id=155f7312"
import script from "./MultiWallet.vue?vue&type=script&setup=true&lang=js"
export * from "./MultiWallet.vue?vue&type=script&setup=true&lang=js"

import "./MultiWallet.vue?vue&type=style&index=0&id=155f7312&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"scripts/dashboard/MultiWallet.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "155f7312"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('155f7312', __exports__)) {
    api.reload('155f7312', __exports__)
  }
  
  module.hot.accept("./MultiWallet.vue?vue&type=template&id=155f7312", () => {
    api.rerender('155f7312', render)
  })

}


export default __exports__